<template>
  <div class="trade_s_c_container">
    <div class="trade_s_c_container__title">
      <el-date-picker v-model="search.year" value-format="yyyy" type="year" :clearable="false" />
      {{ search.year }}年抖音佣金分析
    </div>

    <div class="trade_s_c_container__tool">
      <div class="trade_s_c_container__tool-left">
        {{ search.year }}年退货前GMV总计：{{ stat.gmv_return_bef|numberFormatW
        }}，退货后GMV总计：{{ stat.gmv_return_aft|numberFormatW }}，退货率：{{ stat.rate_return|numberFormat(2)
        }}%，退货前佣金率：{{ stat.rate_return_bef|numberFormat(2)
        }}%，退货后佣金率：{{ stat.rate_return_aft|numberFormat(2)
        }}%，退货前退货后佣金差额：{{ (stat.ci_return_bef - stat.ci_return_aft)|numberFormatW }}。
      </div>
      <div class="trade_s_c_container__tool-right">
        <ml-button icon="el-icon-refresh" type="text" text="初始化数据" @click.native="handleInitStats"
                   style="margin-right: 10px;" />
        <el-radio-group v-model="view">
          <el-radio-button label="图表" />
          <el-radio-button label="列表" />
        </el-radio-group>
      </div>
    </div>
    <div :key="search.year" class="trade_s_c_container__main">
      <t-s-c-chart :search="search" v-if="view === '图表'" :stat.sync="stat" />
      <t-s-c-table v-else :search="search" :stat.sync="stat" />
    </div>
  </div>
</template>
<script>
import { tradeStatCommissionInit } from '@/api/trade_stat_commission'
import MlButton from '@/components/MlButton/index.vue'
import TSCTable from '@/pages/trade_stats/commission/component/table.vue'
import TSCChart from '@/pages/trade_stats/commission/component/chart.vue'
import moment from 'moment'

export default {
  name: 'TradeStatCommission',
  components: { TSCChart, TSCTable, MlButton },
  data() {
    return {
      view: '图表',
      stat: {},
      search: {
        year: moment().format('YYYY')
      }
    }
  },
  methods: {
    handleInitStats: async function() {
      await tradeStatCommissionInit({ year: this.search.year })
      this.$message.success('初始化任务发布，请稍后查看数据。')
    }
  }
}
</script>
<style lang="scss">
.trade_s_c_container {
  font-family: "PH Medium";

  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1vw;
    margin: 1.1vw;
    font-weight: bold;
  }

  &__tool {
    width: 80%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto 1.5vw auto;

    &-left {
      font-size: 12px;
      background: linear-gradient(to right, #FFEDF3, rgba(255, 237, 243, 0.5), rgba(0, 0, 0, 0));
      border-left: 3px solid #fe346e;
      padding: 10px;
      width: calc(100% - 20px - 250px);
    }

    &-right {
      display: flex;
      align-items: center;
      width: 250px;
      justify-content: flex-end;
    }
  }

  &__main {
    height: calc(100vh - 200px - 4.8vw);
    width: 80%;
    margin: 0 auto;
  }

  @media (max-width: 1380px) {
    .chart {
      height: 320px !important;
    }
  }

  .el-table {
    font-weight: bold;
  }

  .el-table--enable-row-hover .el-table__body-wrapper tbody tr:hover > td {
    background-color: #f5f7fa !important; /* 自定义高亮颜色 */
  }

  .el-table .sum-row {
    background: rgba(255, 128, 164, 0.08);
  }

  .el-date-editor {
    width: 29px !important;
    height: 24px !important;

    .el-input__inner {
      display: none;
    }

    .el-icon-date {
      font-size: 18px;
      line-height: 18px;
      margin-bottom: 2px;
      margin-right: 4px;
      cursor: pointer;
      color: #fe346e;
    }
  }
}
</style>
